import { UpdateProjectGroup } from '@/connection/projects/update-project-group';
import { serializeError } from '@/store/utils/serialize-error';
import { ProjectsReducerCreator } from '../types';

const updateProjectGroupReducer = (create: ProjectsReducerCreator) => {
  return create.asyncThunk(
    async (
      {
        channel,
        groupUuid,
        name,
        projectUuids,
        adminIds,
      }: { channel: number; groupUuid: string; name: string; projectUuids: string[]; adminIds: number[] },
      { rejectWithValue }
    ) => {
      try {
        const updatedGroup = await UpdateProjectGroup(channel, groupUuid, name, projectUuids, adminIds);
        return updatedGroup;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      rejected: (state, action) => {
        state.groupError = action.error.message || 'Error updating project group';
      },
      fulfilled: (state, action) => {
        state.groupError = '';
        if (state.projectGroups) {
          state.projectGroups = state.projectGroups.map((pg) =>
            pg.uuid === action.payload.uuid ? action.payload : pg
          );
          state.groupToEdit = null;
        }
      },
    }
  );
};

export default updateProjectGroupReducer;
